import script from "./ClientFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientFormModal.vue?vue&type=script&setup=true&lang=js"

import "./ClientFormModal.vue?vue&type=style&index=0&id=f6b94478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6b94478"]])

export default __exports__